export const tagTokens = {
  tag: {
    root: {
      borderRadius: '{borderRadius.sm}',
      padding: '0.375rem 0.375rem 0.375rem 0.25rem',
      gap: '0.25rem',
      fontSize: '0.875rem',
      fontWeight: '500'
    },
    colorScheme: {
      light: {
        success: {
          background: '{success.background}',
          color: '{success.color}'
        },
        danger: {
          background: '{danger.background}',
          color: '{danger.color}'
        },
        info: {
          background: '{highlight.background}',
          color: '{primary.color}'
        }
      }
    }
  }
};

export type TagTokens = typeof tagTokens;
